import * as React from 'react';
import { HighlightedContentItem, HighlightedContent } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import '@grandvisionhq/state';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsArticleCollectionItem = withEditableContent(({ content  })=>{
    const { coverImage , url , title , summary  } = content;
    const [link] = useBloomreachLinks([
        {
            url: url !== null && url !== void 0 ? url : '#'
        }
    ]);
    const image = parseBloomreachImage(coverImage);
    if (!image) {
        console.error('Missing coverImage');
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightedContentItem, {
        image: image.original,
        text: summary,
        title: title,
        link: link
    });
});
const CmsArticleCollection = ({ content  })=>/*#__PURE__*/ React.createElement(HighlightedContent, null, content.items.map((item)=>/*#__PURE__*/ React.createElement(CmsArticleCollectionItem, {
            key: item.id,
            content: item
        })
    ))
;
var CmsArticleCollection$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withEditableContent, withAnchor)(CmsArticleCollection);

export { CmsArticleCollection, CmsArticleCollectionItem, CmsArticleCollection$1 as default };
//# sourceMappingURL=ArticleCollection.js.map
